var React = require('react');

function ExcludeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.74272 11.0659C8.74272 11.4841 8.40583 11.8094 7.99924 11.8094C7.59264 11.8094 7.25575 11.4841 7.25575 11.0659C7.25575 10.6477 7.59264 10.3224 7.99924 10.3224C8.40583 10.3224 8.74272 10.6477 8.74272 11.0659ZM8.3826 9.40468H7.63911L7.47647 3.44519H8.54523L8.3826 9.40468Z","fill":"currentColor"}));
}

ExcludeInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ExcludeInline;

ExcludeInline.default = ExcludeInline;
